import React, { FunctionComponent, useMemo } from 'react';
import { CONCLUSION, KPI, ROCK_REVIEW, TODO } from '../../../../app/resource/agenda-item/agenda-item.types';
import { meetingTasksPageSelectors } from '../../../../app/page/page-storage/meeting-tasks/meeting-tasks.selectors';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { IMeeting } from '../../../../app/resource/meeting/meeting.types';
import { GoalsBoard } from '../../MeetingDashboardPage/GoalsBoard';
import { WidgetUnimplemented } from '../../common/widgets/WidgetUnimplemented';
import { WidgetConclusion } from '../../common/widgets/WidgetConclusion';
import { WidgetKpi } from '../../common/widgets/widgets-kpi/WidgetKpi';
import { WidgetWrapper } from '../../common/widgets/WidgetWrapper';
import { ScoreFormTrigger } from '../../../dialogs/ScoreFormDialog/ScoreFormTrigger';
import { ActionItemsBoard } from '../../MeetingDashboardPage/ActionItemsBoard';
import { IMeetingSimple } from '../../../../app/resource/meeting-simple/meeting-simple.types';
import { meetingSimpleSelectors } from '../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { ISession } from '../../../../app/resource/session/session.types';

interface IComponentProps {
  currentAgendaItem: any;
  meetingId: IMeeting['id'];
  sessionId: ISession['id'];
}

const LiveMeetingView: FunctionComponent<IComponentProps> = ({ currentAgendaItem, meetingId, sessionId }) => {
  const meetingTasks = useSelect(meetingTasksPageSelectors.selectMeetingTasks)[meetingId];
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId) as IMeetingSimple;
  const shareWithIds = meeting?.shareWithIds.filter((shareId) => !meeting?.administratorIds.includes(shareId));
  const defineKPITableHeight = () => {
    let height = 50;

    // Small screens (window.innerWidth value in px)
    if (window.innerWidth < 1600) {
      height = 40;
    }

    return `${height}vh`;
  };
  const userIds = useMemo(
    () =>
      meeting
        ? meeting.type === 'meeting'
          ? Array.from(new Set([...meeting.administratorIds, ...shareWithIds]))
          : Array.from(new Set([...shareWithIds, ...meeting.administratorIds]))
        : [],
    [meeting, shareWithIds],
  );

  const showLiveComponent = () => {
    if (!currentAgendaItem) {
      return null;
    }
    switch (currentAgendaItem.keyName) {
      case TODO:
        if (meetingTasks) {
          return (
            <>
              <ActionItemsBoard
                userIds={userIds}
                actionItems={meetingTasks.actionItems}
                adminIds={meeting.administratorIds}
                meetingId={meetingId}
              />
            </>
          );
        }
        return null;
      case KPI:
        return (
          <WidgetWrapper
            name="KPI's"
            actionElement={
              <div className="ml-auto flex aic jcr">
                <ScoreFormTrigger meetingId={meetingId} />
              </div>
            }
          >
            <WidgetKpi
              meetingId={meetingId}
              kpisGroupedByUser={meeting?.kpisGroupedByUser ?? false}
              height={defineKPITableHeight()}
            />
          </WidgetWrapper>
        );
      case ROCK_REVIEW:
        if (meetingTasks) {
          return (
            <GoalsBoard
              userIds={userIds}
              goals={meetingTasks.goals}
              adminIds={meeting.administratorIds}
              meetingId={meeting.id}
            />
          );
        }
        return null;
      case CONCLUSION:
        return <WidgetConclusion meetingId={meetingId} sessionId={sessionId} />;
      default:
        return <WidgetUnimplemented agendaItem={currentAgendaItem} meetingId={meetingId} />;
    }
  };

  return <>{showLiveComponent()}</>;
};
export default LiveMeetingView;
